<template>
  <div id="locale-changer">
    <select v-model="$i18n.locale" class="form-control-sm" @change="onChange">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang[0]">{{ lang[1] }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return { langs: [['ja','日本'], ['en', 'English']] }
  },
  methods: {
    onChange(event) {
      this.$cookie.set('locale', this.$i18n.locale)
    }
  }
}
</script>

<style>
  #locale-changer {
    float: left;
    margin-left: 10px;
  }
</style>